import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import Aboutus from "./Components/About Us/Aboutus";
import Body from "./Components/Body/Body";
import Contactus from './Components/Contact us/ContactUs'
import Resources from "./Components/Resources/Resources";
import Keyoffering from "./Components/Keyoffering/Keyoffering";
import Gallery from "./Components/Gallery/Gallery";
import CompleteProject from "./Components/Completed Project/CompleteProject";

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <>
          <Header /> <Body/> <Footer />
        </>
      ),
    },
    {
      path: "/home",
      element: (
        <>
          <Header /> <Body/> <Footer />
        </>
      ),
    },
    {
      path: "/aboutus",
      element: (
        <>
          <Header /> <Aboutus /> <Footer />
        </>
      ),
    },
      {
      path: "/resources",
      element: (
        <>
          <Header /> <Resources /> <Footer />
        </>
      ),
    },
      {
      path: "/key-offering",
      element: (
        <>
          <Header /> <Keyoffering /> <Footer />
        </>
      ),
    },
          {
      path: "/complete-projects",
      element: (
        <>
          <Header /> <CompleteProject /> <Footer />
        </>
      ),
    },
          {
      path: "/gallery",
      element: (
        <>
          <Header /> <Gallery /> <Footer />
        </>
      ),
    },
        {
      path: "/contactus",
      element: (
        <>
          <Header /> <Contactus /> <Footer />
        </>
      ),
    },
  ]);

  return (
    <div>
      <RouterProvider router={router} />
    </div>
  );
};

export default App;
